import { inject, Injectable } from '@angular/core';
import { GrowthBookService } from '@lentau/core/growth-book/shared/growth-book.service';
import { TelegramMiniAppLoadConfig } from '@lentau/ui-kit/core/services/mini-app/telegram-mini-app-detector.interfaces';
import { TelegramMiniAppDetectorService } from '@lentau/ui-kit/core/services/mini-app/telegram-mini-app-detector.service';
import { isRecord } from '@lentau/ui-kit/core/utils/object.utils';

const TELEGRAM_MINI_APP_LOAD_CONFIG_KEY: string = 'web.config.telegramMiniAppLoad';

@Injectable({
  providedIn: 'root',
})
export class TelegramMiniAppBootstrapService {
  private readonly telegramMiniAppDetectorService: TelegramMiniAppDetectorService =
    inject(TelegramMiniAppDetectorService);
  private readonly growthBookService: GrowthBookService = inject(GrowthBookService);

  public init(): void {
    if (!this.telegramMiniAppDetectorService.isTelegramMiniAppContext()) {
      return;
    }

    this.telegramMiniAppDetectorService.setLoadConfig(this.getTelegramMiniAppLoadConfig());
    void this.telegramMiniAppDetectorService.initTelegramMiniApp();
  }

  private getTelegramMiniAppLoadConfig(): Partial<TelegramMiniAppLoadConfig> {
    const featureValue: unknown = this.growthBookService.getFeatureValue<Record<string, unknown>>(
      TELEGRAM_MINI_APP_LOAD_CONFIG_KEY
    ).value;

    if (!isRecord(featureValue)) {
      return {};
    }

    return {
      scriptTimeoutMs: featureValue.scriptTimeoutMs as number | undefined,
      retryDelaysMs: featureValue.retryDelaysMs as number[] | undefined,
    };
  }
}
